module.exports = __webpack_public_path__ + "static/media/watermelon.135112e3.png";